export const INCENTIVES_HELP_URL = 'https://help.bonus.ly/en/articles/3041445-managing-incentives';
export const INCENTIVES_BLOG_URL = 'https://help.bonus.ly/en/articles/2992611-how-to-set-up-incentives';
